// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChevronUpIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="m7.839 14.757 4.166-4.166 4.167 4.166a1.07 1.07 0 1 0 1.514-1.514l-4.929-4.929a1.07 1.07 0 0 0-1.514 0l-4.929 4.929a1.07 1.07 0 0 0 0 1.514 1.09 1.09 0 0 0 1.525 0"
    />
  </g>
);
export default SvgChevronUpIcon;
SvgChevronUpIcon.displayName = 'SvgChevronUpIcon';
